import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../utils/api"; // adjust path if needed


const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5000";

const BookingConfirmation = () => {
  const { refCode } = useParams();
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!refCode) return;

    const fetchBooking = async () => {
      try {
        const userEmail = localStorage.getItem("usrEmail") || "";



const response = await fetch(`${API_BASE}/api/bookings/${refCode}`, {
  headers: {
    "x-user-email": userEmail,
  },
});



        if (response.status === 404) {
          setError("❌ Booking not found.");
          return;
        }
        if (response.status === 403) {
          setError("⚠️ Access denied for this booking.");
          return;
        }

        const data = await response.json();
        setBooking(data);
      } catch (err) {
        console.error("Error fetching booking:", err);
        setError("⚠️ An unexpected error occurred while fetching booking details.");
      } finally {
        setLoading(false);
      }
    };

    fetchBooking();
  }, [refCode]);

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "60px" }}>
        <h2>Loading confirmation details...</h2>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ textAlign: "center", marginTop: "60px" }}>
        <h2>{error}</h2>
        <Link to="/" style={{ color: "#007bff", textDecoration: "underline" }}>Return Home</Link>
      </div>
    );
  }

  if (!booking) {
    return (
      <div style={{ textAlign: "center", marginTop: "60px" }}>
        <h2>Booking not found.</h2>
        <Link to="/" style={{ color: "#007bff", textDecoration: "underline" }}>Return Home</Link>
      </div>
    );
  }

  return (
    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
      backgroundColor: "#f8f9fa"
    }}>
      <div style={{
        background: "#fff",
        padding: "30px",
        borderRadius: "12px",
        textAlign: "center",
        maxWidth: "420px",
        width: "100%",
        boxShadow: "0 6px 14px rgba(0,0,0,0.12)"
      }}>
        <h2 style={{ color: "#28a745", marginBottom: "15px" }}>✅ Payment Successful</h2>
        <p>Thank you for your booking!</p>
        <p><strong>Booking Reference:</strong> {booking.ref_code}</p>
        <p><strong>Pickup:</strong> {booking.pickup_location}</p>
        <p><strong>Dropoff:</strong> {booking.dropoff_location}</p>
        <p><strong>Fare Paid:</strong> £{booking.fare}</p>

        <div style={{ marginTop: "20px" }}>
          <Link
            to="/"
            style={{
              display: "inline-block",
              backgroundColor: "#007bff",
              color: "white",
              padding: "10px 20px",
              fontSize: "16px",
              fontWeight: "bold",
              borderRadius: "6px",
              textDecoration: "none"
            }}
          >
            ⬅ Return Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BookingConfirmation;

